import {MdOutlineDashboardCustomize,MdDashboard} from 'react-icons/md'
import {FaUserAlt,FaUserCog} from 'react-icons/fa'
import {AiTwotoneShop,AiFillSetting} from 'react-icons/ai'
import {SiLogstash} from 'react-icons/si'
import {BiLogOut} from 'react-icons/bi'
import {MdHomeWork,MdRealEstateAgent,MdNotifications} from 'react-icons/md'
import {RiAdvertisementFill,RiGitPullRequestFill} from 'react-icons/ri'
import {GiVerticalBanner} from 'react-icons/gi'
import {ImOffice} from 'react-icons/im'
export const sideBarLinks=[
    {
        title:'Dashboard',
        links:[
            {
                name:'dashboard',
                link:'dashboard',
                icon :<MdDashboard size={22} className=' text-[#96a0af]'/>
            }
        ]
    },
    {
        title:'Lists',
        links:[
            {
                name:'properties',
                link:'properties',
                icon :<MdHomeWork size={18} className=' text-[#96a0af]'/>
            },
            {
                name:'agents',
                link:'agents',
                icon :<MdRealEstateAgent size={18} className=' text-[#96a0af]'/>
            },
            {
                name:'users',
                link:'users',
                icon :<FaUserAlt size={16} className=' text-[#96a0af]'/>
            },
            {
                name:'companies',
                link:'companies',
                icon :<ImOffice size={18} className=' text-[#96a0af]'/>
            },
            {
                name:'real estates',
                link:'real-estates',
                icon :<ImOffice size={18} className=' text-[#96a0af]'/>
            },
        ]
    },
    {
        title:'Requests',
        links:[
            {
                name:'property ads',
                link:'ads',
                icon :<RiAdvertisementFill size={20} className=' text-[#96a0af]'/>
            },
            {
                name:'Banner ads',
                link:'banner',
                icon :<GiVerticalBanner size={20} className=' text-[#96a0af]'/>
            },
             {
                name:'company',
                link:'company',
                icon :<RiGitPullRequestFill size={20} className=' text-[#96a0af]'/>
            },
            {
                link:'notification',
                name:'notifications',
                icon :<MdNotifications size={20} className=' text-[#96a0af]'/>
            }
        ]
    },
    {
        title:'User',
        links:[
            {
                name:'profile',
                link:'profile',
                icon :<FaUserCog size={20} className=' text-[#96a0af]'/>
            },
         
        
        ]
    }
]